import { render, staticRenderFns } from "./HorizontalBarChart.vue?vue&type=template&id=394eb5fe&scoped=true&"
import script from "./HorizontalBarChart.vue?vue&type=script&lang=js&"
export * from "./HorizontalBarChart.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalBarChart.vue?vue&type=style&index=0&id=394eb5fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394eb5fe",
  null
  
)

export default component.exports